import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getMonthlyPl({ startDate, endDate }) {
    return axiosIns.get(
      '/admin/monthly_pl',
      {
        params: snakecaseKeys({ startDate, endDate }),
      },
    )
  },
  downloadCsv({ startDate, endDate }) {
    return axiosIns.get(
      '/admin/monthly_pl_csv',
      {
        params: snakecaseKeys({ startDate, endDate }),
        responseType: 'blob',
      },
    )
  },
  downloadXlsx({ startDate, endDate }) {
    return axiosIns.get(
      '/admin/monthly_pl_xlsx',
      {
        params: snakecaseKeys({ startDate, endDate }),
        responseType: 'blob',
      },
    )
  },
}
